'use client';

import { useEffect, useRef } from 'react';
import { useParams, useRouter } from 'next/navigation';
import Image from 'next/image';

const ErrorComponent = ({ pageNotFound = false }) => {
    const router = useRouter();
    const params = useParams();
    const { locale } = params;

    const targetRef = useRef(null); // 綁定 3D 效果圖片的 ref

    // 處理滑鼠移動的 3D 效果
    const handleMouseMove = (e) => {
        const { clientX, clientY } = e;
        const { innerWidth, innerHeight } = window;

        // 計算滑鼠比例
        const xRatio = (clientX / innerWidth - 0.5) * 2; // -1 到 1
        const yRatio = (clientY / innerHeight - 0.5) * 2;

        // 設置旋轉角度
        const rotateX = yRatio * 15; // 調整旋轉強度
        const rotateY = -xRatio * 15;

        // 應用旋轉到圖片
        if (targetRef.current) {
            targetRef.current.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
        }
    };

    useEffect(() => {
        // 綁定事件監聽器
        document.addEventListener('mousemove', handleMouseMove);

        // 清除監聽器
        return () => document.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <div
            data-page-not-found={pageNotFound ? '' : undefined}
            className="w-full mx-auto px-[30px] uxs:px-[15px] pt-[40px] pb-[65px] ulg:pb-[50px] min-h-[calc(100vh-260px)] ulg:min-h-[unset]"
        >
            <div className="w-full max-w-[823px] mx-auto">
                {/* 圖片容器 */}
                <div className="img-box w-full aspect-[672/330] max-w-[672px] mx-auto perspective-[800px] relative">
                    {/* 靜態背景圖 */}
                    <Image
                        loading="eager"
                        width={672}
                        height={330}
                        src="/images/layout/error.webp"
                        alt="error"
                        className="absolute z-[1]"
                    />
                    {/* 3D 效果圖片 */}
                    <div
                        ref={targetRef}
                        className="absolute w-full h-full bg-cover bg-center z-[2] transition-transform duration-150 ease-linear"
                        style={{
                            backgroundImage: "url('/images/layout/error_2.webp')",
                        }}
                    />
                </div>

                {/* 文字與按鈕 */}
                <div className="space-y-[6px] text-center text-plum">
                    <p className="text-[36px] text-vPurple font-[700] tracking-[.8px] leading-[180%]">
                        Looks like you got lost
                    </p>

                    <p className="text-bd5b">看起來誤闖後門的你迷路了</p>

                    <p className="text-bd1m">您可以返回首頁或使用搜索功能尋找其他相關新聞</p>
                </div>

                {/* 返回首頁按鈕 */}
                <button
                    onClick={() => router.push('/')}
                    className="mx-auto block mt-[28px] text-white bg-vPurple trans hover:bg-plum rounded-[40px] w-full max-w-[260px] py-[11px] text-btn1"
                >
                    返回首頁
                </button>
            </div>
        </div>
    );
};

export default ErrorComponent;
